import * as React from 'react'
import { SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const DollarRoundedIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8.396 14.98h1.146v-1.084c.847-.097 1.507-.358 1.979-.781.472-.424.708-.99.708-1.698 0-.709-.201-1.285-.604-1.73-.403-.444-1.083-.867-2.042-1.27-.805-.334-1.389-.632-1.75-.896a1.25 1.25 0 0 1-.541-1.063c0-.43.156-.77.468-1.02.313-.25.74-.375 1.282-.375.416 0 .777.097 1.083.291.306.195.563.486.77.875l1-.479c-.235-.486-.548-.868-.937-1.146a2.83 2.83 0 0 0-1.375-.5V3.042H8.438v1.062c-.709.097-1.268.358-1.678.782-.41.423-.614.947-.614 1.572 0 .681.208 1.223.625 1.625.417.403 1.042.778 1.875 1.125.93.39 1.57.74 1.916 1.053.348.312.521.697.521 1.156 0 .444-.184.802-.552 1.073-.368.27-.83.406-1.385.406a2.413 2.413 0 0 1-1.448-.458 2.376 2.376 0 0 1-.885-1.25l-1.063.354c.292.639.65 1.142 1.073 1.51.424.368.948.636 1.573.802v1.125ZM9 17.332a8.063 8.063 0 0 1-3.23-.656 8.454 8.454 0 0 1-2.655-1.791 8.452 8.452 0 0 1-1.792-2.657A8.063 8.063 0 0 1 .667 9c0-1.153.218-2.236.656-3.25a8.328 8.328 0 0 1 1.792-2.646A8.543 8.543 0 0 1 5.77 1.323 8.063 8.063 0 0 1 9 .667c1.153 0 2.236.218 3.25.656a8.416 8.416 0 0 1 2.646 1.781 8.415 8.415 0 0 1 1.781 2.646A8.115 8.115 0 0 1 17.333 9a8.063 8.063 0 0 1-.656 3.23 8.542 8.542 0 0 1-1.781 2.655 8.33 8.33 0 0 1-2.646 1.792 8.115 8.115 0 0 1-3.25.656Zm0-1.25c1.972 0 3.646-.69 5.02-2.072 1.376-1.382 2.063-3.053 2.063-5.01 0-1.973-.687-3.647-2.062-5.022C12.646 2.604 10.972 1.917 9 1.917c-1.958 0-3.628.687-5.01 2.062C2.608 5.354 1.917 7.028 1.917 9c0 1.958.69 3.629 2.073 5.01 1.382 1.382 3.052 2.073 5.01 2.073Z"
      fill="#777877"
    />
  </svg>
)

export default DollarRoundedIcon
